import { render } from "./AppointmentRequests.vue?vue&type=template&id=3f75c8e3"
import script from "./AppointmentRequests.vue?vue&type=script&lang=js"
export * from "./AppointmentRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__